import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {OccupationZoneDeTravailDto} from '../dto/occupation-zone-de-travail.dto';
import {HttpClient, HttpParams} from '@angular/common/http';
import {DateUtilsService} from './date-utils.service';
import {AuthService} from './auth-service.service';

@Injectable({
	providedIn: 'root'
})
export class ZoneDeTravailService {

	private url = '/ws/zones-de-travail';

	constructor(
		private http: HttpClient,
		private dateUtilsService: DateUtilsService,
		private authService: AuthService) {
	}

	/**
	 * Récupère les taux d'occupation de la zone de travail pour une période.
	 * @param dateDebut
	 * @param dateFin
	 * @param loginOccupant
	 */
	recupererTauxOccupationZoneDeTravailPourPeriode(dateDebut: Date, dateFin: Date, loginOccupant: string): Observable<OccupationZoneDeTravailDto[]> {
		const locale = this.authService.getUtilisateurConnecte().langue;

		const dateDebutPourEnvoi = this.dateUtilsService.formaterDateEnStringPourEnvoiBack(dateDebut, locale);
		const dateFinPourEnvoi = this.dateUtilsService.formaterDateEnStringPourEnvoiBack(dateFin, locale);

		const params = new HttpParams()
			.set('use-case', 'taux-occupation')
			.set('dateDebut', dateDebutPourEnvoi)
			.set('dateFin', dateFinPourEnvoi)
			.set('loginOccupant', loginOccupant);

		return this.http.get<OccupationZoneDeTravailDto[]>(this.url, {params: params});
	}
}
